export interface MobileDeviceType {
    name: string;
    key: string;
    img: string;
}

export interface MobileDevice {
    name: string;
    key: string;
    types: MobileDeviceType[];
}

export const mobileDevices: MobileDevice[] = [
    {
        'name': 'IOS',
        'key': 'ios',
        'types': [
            {
                'name': 'iPhone 12',
                'key': 'iphone-12',
                'img': 'iphone-12.png'
            },
            {
                'name': 'iPhone 11',
                'key': 'iphone-11',
                'img': 'iphone-11.png'
            },
            {
                'name': 'iPhone X',
                'key': 'iphone-x',
                'img': 'iphone-x.png'
            },
            {
                'name': 'iPhone 6/7/8 Plus',
                'key': 'iphone-6-7-8-plus',
                'img': 'iphone-6-7-8-plus.png'
            },
            {
                'name': 'iPhone 6/7/8',
                'key': 'iphone-6-7-8',
                'img': 'iphone-6-7-8.png'
            },
            {
                'name': 'iPhone 5/SE',
                'key': 'iphone-5-SE',
                'img': 'iphone-5-SE.png'
            },
            {
                'name': 'iPad Pro',
                'key': 'ipad-pro',
                'img': 'ipad-pro.png'
            }
            ,
            {
                'name': 'iPad',
                'key': 'ipad',
                'img': 'ipad.png'
            }
        ]
    },
    {
        'name': 'Andriod',
        'key': 'andriod',
        'types': [
            {
                'name': 'Honeywell CT60',
                'key': 'honeywell-CT60',
                'img': 'honeywell-CT60.png'
            },
            {
                'name': 'Google Pixel',
                'key': 'google-pixel',
                'img': 'google-pixel.png'
            },
            {
                'name': 'Samsung Galaxy',
                'key': 'samsung-galaxy',
                'img': 'samsung-galaxy.png'
            },
            {
                'name': 'Samsung Note',
                'key': 'samsung-note',
                'img': 'samsung-note.png'
            },
            {
                'name': 'Samsung Tablet',
                'key': 'samsung-tablet',
                'img': 'samsung-tablet.png'
            },
            {
                'name': 'Zebra TC56',
                'key': 'Zebra-TC56',
                'img': 'Zebra-TC56.png'
            }
        ],
    }];